import CloseIcon from '@mui/icons-material/Close';
import type { AlertProps } from '@qbe/ads-core';
import { Alert, Box } from '@qbe/ads-core';
import { CustomContentProps, useSnackbar } from 'notistack';
import type { Ref } from 'react';
import * as React from 'react';
import { useCallback } from 'react';

export interface SnackbarItemProps
  extends CustomContentProps, Pick<AlertProps, 'heading' | 'inlineHeading'> {
  ref?: Ref<unknown>;
}

// React 19: ref is now a standard prop, forwardRef is deprecated
export const SnackbarItem = (props: SnackbarItemProps) => {
  const { ref, id, message, persist, heading, inlineHeading, variant = 'info', ...rest } = props;
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  let dismissableProps = {};
  if (typeof persist !== 'undefined') {
    dismissableProps = {
      closeIconProps: { muiIcon: CloseIcon, color: 'inherit' },
      onClose: handleDismiss,
    };
  }

  return (
    <Box
      ref={ref}
      sx={{
        width: {
          sm: '320px',
          md: '400px',
        },
      }}
    >
      <Alert
        role="alert"
        {...dismissableProps}
        sx={{ width: '100%', display: 'flex' }}
        id={String(id)}
        heading={heading}
        inlineHeading={inlineHeading}
        variant={variant as AlertProps['variant']}
        {...rest}
      >
        {message}
      </Alert>
    </Box>
  );
};
